import { c as _c } from "react/compiler-runtime";
import CloudDone from "@mui/icons-material/CloudDone";
import CloudQueue from "@mui/icons-material/CloudQueue";
import CloudSync from "@mui/icons-material/CloudSync";
import SdCardAlert from "@mui/icons-material/SdCardAlert";
import { Tooltip } from "@mui/material";
import React from "react";
import { useI18nContext } from "#/shared/hooks";
export enum EditorState {
  INITIAL,
  PENDING_CHANGES,
  SAVED_ON_SERVER,
  FORKED_UNAUTHENTICATED,
  FORKED_UNOWNED,
}
type EditorStateIconProps = {
  state: EditorState;
  isLoading?: boolean;
};
export const EditorStateIcon: React.FC<EditorStateIconProps> = t0 => {
  const $ = _c(24);
  const {
    state,
    isLoading
  } = t0;
  const {
    LL
  } = useI18nContext();
  let icon;
  let text;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CloudSync />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    icon = t1;
    let t2;
    if ($[1] !== LL) {
      t2 = LL.SYNCING_WITH_SERVER();
      $[1] = LL;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    text = `${t2}...`;
  } else {
    bb0: switch (state) {
      default:
      case EditorState.SAVED_ON_SERVER:
        {
          let t1;
          if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = <CloudDone />;
            $[3] = t1;
          } else {
            t1 = $[3];
          }
          icon = t1;
          let t2;
          if ($[4] !== LL) {
            t2 = LL.SAVED_IN_THE_CLOUD();
            $[4] = LL;
            $[5] = t2;
          } else {
            t2 = $[5];
          }
          text = `${t2} ✅`;
          break bb0;
        }
      case EditorState.PENDING_CHANGES:
        {
          let t1;
          if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = <CloudQueue />;
            $[6] = t1;
          } else {
            t1 = $[6];
          }
          icon = t1;
          let t2;
          if ($[7] !== LL) {
            t2 = LL.PENDING_CHANGES();
            $[7] = LL;
            $[8] = t2;
          } else {
            t2 = $[8];
          }
          text = `${t2}...`;
          break bb0;
        }
      case EditorState.FORKED_UNAUTHENTICATED:
        {
          let t1;
          if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = <SdCardAlert color="warning" />;
            $[9] = t1;
          } else {
            t1 = $[9];
          }
          icon = t1;
          let t2;
          if ($[10] !== LL) {
            t2 = LL.YOU_NEED_TO_BE_AUTHED_TO_SAVE_CODE();
            $[10] = LL;
            $[11] = t2;
          } else {
            t2 = $[11];
          }
          let t3;
          if ($[12] !== LL) {
            t3 = LL.YOUR_CHANGES_WILL_BE_LOST();
            $[12] = LL;
            $[13] = t3;
          } else {
            t3 = $[13];
          }
          text = `${t2}! \n${t3}! 😱`;
          break bb0;
        }
      case EditorState.FORKED_UNOWNED:
        {
          let t1;
          if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = <SdCardAlert color="warning" />;
            $[14] = t1;
          } else {
            t1 = $[14];
          }
          icon = t1;
          let t2;
          if ($[15] !== LL) {
            t2 = LL.YOU_DONT_OWN_THIS_PROJECT();
            $[15] = LL;
            $[16] = t2;
          } else {
            t2 = $[16];
          }
          let t3;
          if ($[17] !== LL) {
            t3 = LL.YOUR_CHANGES_WILL_BE_LOST();
            $[17] = LL;
            $[18] = t3;
          } else {
            t3 = $[18];
          }
          text = `${t2}! \n${t3}! 😱`;
        }
    }
  }
  let t1;
  if ($[19] !== text) {
    t1 = text.split("\n").map(_temp);
    $[19] = text;
    $[20] = t1;
  } else {
    t1 = $[20];
  }
  let t2;
  if ($[21] !== icon || $[22] !== t1) {
    t2 = <Tooltip title={t1} arrow={true} placement="left">{icon}</Tooltip>;
    $[21] = icon;
    $[22] = t1;
    $[23] = t2;
  } else {
    t2 = $[23];
  }
  return t2;
};
function _temp(str) {
  return <div key={str}>{str}</div>;
}